// Pantalla a la que llega el estudiante cuando le da clic al link de
// confirmacion en su correo. Antes de esto, Supabase lo mandaba a un
// dominio viejo que ya no existe -- este archivo es el mismo arreglo que
// se hizo en EspanolGo, con la marca de EnglishBridge.
//
// "Elegir mi plan" ya NO recarga toda la pagina con window.location.href:
// App.js ya dejo la sesion activa (verifyOtp) en este mismo cargue, asi que
// onContinuar() sigue con ella directo hacia precios -- una recarga completa
// arriesgaba a perder esa sesion recien creada y devolver al estudiante al
// landing en vez de a los planes.
export default function EmailConfirmado({ onContinuar }) {
  function volverAPlataforma() {
    try { window.localStorage.setItem('englishbridge_email_confirmado', '1') } catch (err) {}
    if (onContinuar) {
      onContinuar()
    } else {
      window.location.href = '/'
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(145deg, #0D1F52 0%, #1B3A8C 55%, #0a1836 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif', padding: 24
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: '48px 36px', maxWidth: 440, width: '100%',
        textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0D1F52', marginBottom: 10 }}>
          Bienvenido a EduNova - EnglishBridge
        </h1>
        <p style={{ fontSize: 15, color: '#6B7280', marginBottom: 32, lineHeight: 1.6 }}>
          Tu correo ya quedó confirmado — gracias por darle la bienvenida al inglés en tu vida.<br /><br />
          Cada clase, cada palabra nueva, te acerca un poco más a hablarlo con confianza. Elige tu plan y da hoy el primer paso.
        </p>
        <button onClick={volverAPlataforma} style={{
          background: 'linear-gradient(135deg,#D4AF37,#B8912C)', border: 'none', color: '#0D1F52',
          fontFamily: 'inherit', fontSize: 15, fontWeight: 800, cursor: 'pointer',
          padding: '14px 32px', borderRadius: 12, width: '100%'
        }}>
          Elegir mi plan →
        </button>
      </div>
    </div>
  )
}
